/**
 * Validates player age against age category using fixed birth date ranges
 * @param {string|Date} dob - Date of birth (string in YYYY-MM-DD format or Date object)
 * @param {string} ageCategory - Age category ('boys_u14', 'girls_u15', 'boys_u16')
 * @returns {string|null} - Error message if validation fails, null if validation passes
 */
export const validatePlayerAge = (dob, ageCategory) => {
  if (!dob || !ageCategory) return null;
  
  const birthDate = new Date(dob);
  birthDate.setHours(0, 0, 0, 0);
  
  // Validate based on age category using fixed birth date ranges
  if (ageCategory === 'boys_u14') {
    // U14 Boys: Born between Sep 1, 2012 and Aug 31, 2015 (inclusive)
    const u14Start = new Date('2012-09-01');
    u14Start.setHours(0, 0, 0, 0);
    const u14End = new Date('2015-09-01'); // Next day for exclusive comparison
    u14End.setHours(0, 0, 0, 0);
    
    if (birthDate < u14Start) {
      return 'Player is overage for U14 category. Must be born on or after September 1, 2012.';
    }
    if (birthDate >= u14End) {
      return 'Player is underage for U14 category. Must be born on or before August 31, 2015.';
    }
  } else if (ageCategory === 'girls_u15') {
    // U15 Girls: Born between Sep 1, 2011 and Aug 31, 2014 (inclusive)
    const u15Start = new Date('2011-09-01');
    u15Start.setHours(0, 0, 0, 0);
    const u15End = new Date('2014-09-01');
    u15End.setHours(0, 0, 0, 0);
    
    if (birthDate < u15Start) {
      return 'Player is overage for U15 category. Must be born on or after September 1, 2011.';
    }
    if (birthDate >= u15End) {
      return 'Player is underage for U15 category. Must be born on or before August 31, 2014.';
    }
  } else if (ageCategory === 'boys_u16') {
    // U16 Boys: Born between Sep 1, 2010 and Aug 31, 2012 (inclusive)
    const u16Start = new Date('2010-09-01');
    u16Start.setHours(0, 0, 0, 0);
    const u16End = new Date('2012-09-01');
    u16End.setHours(0, 0, 0, 0);
    
    if (birthDate < u16Start) {
      return 'Player is overage for U16 category. Must be born on or after September 1, 2010.';
    }
    if (birthDate >= u16End) {
      return 'Player is underage for U16 category. Must be born on or before August 31, 2012.';
    }
  }
  
  return null; // Validation passed
};

